let generation=0,signature='',owner=null,preferences={},blocked=new Set();
export function setContactContext(accountId,map,ids){const next=(accountId||'')+'|'+[...ids].sort().join('|');if(next!==signature){generation++;signature=next}owner=accountId;preferences=map;blocked=new Set(ids)}
export function personalName(person){return owner&&person?.id?preferences[person.id]?.nickname||null:null}
export function contactBlocked(id){return !!owner&&!!id&&blocked.has(id)}
export function contactMuted(id){return !!owner&&!!id&&!!preferences[id]?.notificationsMuted}
export const contactScope=()=>String(generation);
